import * as yup from "yup";
import { requiredIdentitySideSchema } from "screens/Private/Broker/Projects/Detail/Templates/Comparison/Acoris/utils/identityDocuments";

const validation = (
  messages,
  {
    needsCA06,
    requiresSubscriberPaysButDifferentReceiver,
    requiresThirdPartyPayer,
    requiresBothThirdParty,
    requiresTwoSeparateRibs,
    requiresEligibilityProof,
  },
) => {
  const requiresSubscriberPaysButDifferentReceiverCondition =
    requiresSubscriberPaysButDifferentReceiver ?? false;
  const requiresThirdPartyPayerCondition = requiresThirdPartyPayer ?? false;
  const requiresBothThirdPartyCondition = requiresBothThirdParty ?? false;
  const requiresTwoRibs = requiresTwoSeparateRibs ?? needsCA06;
  return yup.object().shape({
    // CA-01: Social security certificate - Always required
    socialSecurityCertificate: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        }),
      )
      .required(messages.REQUIRED_ATTACHMENT)
      .min(1, messages.REQUIRED_ATTACHMENT),

    // CA-02: RIB - Payment account always required
    paymentAccount: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        }),
      )
      .required(messages.REQUIRED_ATTACHMENT)
      .min(1, messages.REQUIRED_ATTACHMENT),

    // Refund account - required when two separate RIBs needed
    refundAccount: requiresTwoRibs
      ? yup
          .array()
          .of(
            yup.object().shape({
              name: yup.string().required(messages.REQUIRED),
            }),
          )
          .required(messages.REQUIRED_ATTACHMENT)
          .min(1, messages.REQUIRED_ATTACHMENT)
      : yup.array().nullable(),

    // CA-03: Proof of address - optional, never blocks
    proofOfAddress: yup.array().nullable(),

    // CA-04: Proof of eligibility - optional, never blocks
    proofOfEligibility: requiresEligibilityProof
      ? yup
          .array()
          .of(
            yup.object().shape({
              name: yup.string().required(messages.REQUIRED),
            }),
          )
          .required(messages.REQUIRED_ATTACHMENT)
          .min(1, messages.REQUIRED_ATTACHMENT)
      : yup.array().nullable(),

    // CIN adherent - always required (recto + verso)
    cinRecto: requiredIdentitySideSchema(messages),
    cinVerso: requiredIdentitySideSchema(messages),

    payerCinRecto:
      requiresThirdPartyPayerCondition || requiresBothThirdPartyCondition
        ? requiredIdentitySideSchema(messages)
        : yup.array().nullable(),

    payerCinVerso:
      requiresThirdPartyPayerCondition || requiresBothThirdPartyCondition
        ? requiredIdentitySideSchema(messages)
        : yup.array().nullable(),

    receiverCinRecto:
      requiresSubscriberPaysButDifferentReceiverCondition ||
      requiresBothThirdPartyCondition
        ? requiredIdentitySideSchema(messages)
        : yup.array().nullable(),

    receiverCinVerso:
      requiresSubscriberPaysButDifferentReceiverCondition ||
      requiresBothThirdPartyCondition
        ? requiredIdentitySideSchema(messages)
        : yup.array().nullable(),

    // Tiers payeur: attestation sur l'honneur (JSON parcours).
    contributionPaymentAgreement:
      requiresThirdPartyPayerCondition || requiresBothThirdPartyCondition
        ? yup
            .array()
            .of(
              yup.object().shape({
                name: yup.string().required(messages.REQUIRED),
              }),
            )
            .required(messages.REQUIRED_ATTACHMENT)
            .min(1, messages.REQUIRED_ATTACHMENT)
        : yup.array().nullable(),

    socialSecurityCertificateForChildren: yup.boolean().nullable(),
  });
};

export default validation;
